import React, { useRef, useEffect, useState } from "react";
import { shallowEqual, useSelector, connect, useDispatch } from "react-redux";

import { actions as authActions } from "store/authRedux/actions";
import { actions as commonActions } from "store/commonRedux/actions";

import { SplashScreen } from "components";

import {
  GetUserByRefresh,
  GetUserByToken,
  LogoutBlacklist,
} from "services/account";

import { toast } from "react-toastify";
function AuthProvider(props) {
  const { refreshToken, isAuthorized, userInfo, isImpersonation } = useSelector(
    ({ auth }) => ({
      refreshToken: auth.refresh,
      isAuthorized: auth.access != null,
      userInfo: auth.user,
      isImpersonation: auth.isImpersonation,
    }),
    shallowEqual
  );
  const channelId = useSelector(({ common }) => common.channelId);

  const didRequest = useRef(false);
  const dispatch = useDispatch();

  const [showSplashScreen, setShowSplashScreen] = useState(true);

  useEffect(() => {
    const requestUser = async () => {
      try {
        if (!didRequest.current) {
          if (refreshToken) {
            // fetch new access token
            const access = await GetUserByRefresh(refreshToken);
            dispatch(authActions.refresh(access.access));

            // fetch user by access token
            const user = await GetUserByToken();
            dispatch(authActions.setUser({ ...user }));

            // if (
            //   JSON.stringify(userInfo.channel) != JSON.stringify(user.channel)
            // ) {
            //   // Check and Set User Channel Status
            //   let channelId = user.channel.includes(
            //     parseInt(process.env.REACT_APP_B2B_CHANNEL_ID),
            //   )
            //     ? 'B2B'
            //     : 'B2C'
            //   let channel_toggle = channelId == 'B2B'
            //   dispatch(commonActions.setUserChannels(channelId, channel_toggle))
            // }
          }
        }
      } catch (error) {
      } finally {
        setShowSplashScreen(false);
      }

      return () => (didRequest.current = true);
    };

    if (isAuthorized && !isImpersonation) {
      requestUser();
    } else {
      setShowSplashScreen(false);

      if (channelId == "B2B") {
        dispatch(commonActions.resetUserVariables());
      }
    }
  }, [refreshToken]);

  return showSplashScreen ? <SplashScreen /> : <>{props.children}</>;
}

export default AuthProvider;
